import { addLocalDays, startOfLocalDay } from '../../../../Utils/dates/localDay';
import { formatShortDate, formatTime } from '../../../../Utils/dates/formatDate';
import { formatKm } from '../../../../Utils/format/pace';

/**
 * Sessions of the last 7 local days (today and the 6 before) that have already started, newest
 * first. Only a past Assigned session can be marked completed. `now` is a parameter.
 */
export const buildPastWorkouts = (rows, now) => {
    const from = addLocalDays(startOfLocalDay(now), -6);
    return (rows || [])
        .filter(r => {
            const start = new Date(r.workoutStart);
            return start >= from && start <= now;
        })
        .sort((a, b) => new Date(b.workoutStart) - new Date(a.workoutStart))
        .map(r => {
            const completed = r.status === 'Completed';
            const minutes = completed ? r.swimmingDurationMin ?? r.trainingDurationMin : r.trainingDurationMin;
            const parts = [`${formatKm(r.volume)} km`];
            if (minutes != null) parts.push(completed ? `${minutes} min swum` : `~${minutes} min planned`);
            if (r.status === 'Assigned') parts.push('not marked completed');
            return {
                id: r.id,
                title: r.title || 'Workout',
                dateLabel: formatShortDate(r.workoutStart),
                time: formatTime(r.workoutStart),
                status: r.status,
                canComplete: r.status === 'Assigned',
                detail: parts.join(' · ')
            };
        });
};
